import FormattedMessage from 'I18n/components/FormattedMessage';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
export const CompanyTargetAccountStatusCell = ({
  value
}) => {
  if (value === true || value === 'true') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.companyTargetAccountStatus.isTargetAccount"
    });
  } else if (value === false || value === 'false') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "tasks-table.cells.companyTargetAccountStatus.isNotTargetAccount"
    });
  }
  return /*#__PURE__*/_jsx(UITruncateString, {
    children: value
  });
};